var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11133 7.55556C3.11133 5.59188 4.7032 4 6.66688 4H17.3336C19.2972 4 20.8891 5.59188 20.8891 7.55556V16.4444C20.8891 18.4081 19.2972 20 17.3336 20H6.66688C4.7032 20 3.11133 18.4081 3.11133 16.4444V7.55556Z",
    stroke: "#C7CBD7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8882 9.33301L20.8882 14.6663H17.3327C15.8599 14.6663 14.666 13.4724 14.666 11.9997C14.666 10.5269 15.8599 9.33301 17.3327 9.33301L20.8882 9.33301Z",
    stroke: "#C7CBD7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b5e19bc356be830c76a3c893799cf545.svg";
export { ForwardRef as ReactComponent };